import styles from "./analytics-cards.module.css"

export default function AlertsSummary({ alerts }) {
  if (!alerts || !alerts.recent) {
    return (
      <div className={styles.card}>
        <h3>Alerts Summary</h3>
        <div className={styles.alertStats}>
          <p className={styles.noData}>No alerts data available</p>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.card}>
      <h3>Alerts Summary</h3>
      <div className={styles.alertStats}>
        <div className={styles.alertItem}>
          <span className={styles.alertCount}>{alerts.total || 0}</span>
          <span className={styles.alertLabel}>Total</span>
        </div>
        <div className={styles.alertItem}>
          <span className={`${styles.alertCount} ${styles.critical}`}>{alerts.critical || 0}</span>
          <span className={styles.alertLabel}>Critical</span>
        </div>
        <div className={styles.alertItem}>
          <span className={`${styles.alertCount} ${styles.warning}`}>{alerts.recent?.length || 0}</span>
          <span className={styles.alertLabel}>Recent</span>
        </div>
      </div>

      {alerts.recent && alerts.recent.length > 0 && (
        <div className={styles.recentAlerts}>
          <h4 className={styles.recentTitle}>Recent Alerts</h4>
          {alerts.recent.slice(0, 3).map((alert, index) => (
            <div key={alert._id || index} className={styles.alertRow}>
              <div className={styles.alertInfo}>
                <span className={`${styles.alertBadge} ${styles[alert.severity]}`} title={alert.severity}>
                  {alert.severity === "critical" ? "🔴" : alert.severity === "warning" ? "🟡" : "🔵"}
                </span>
                <div className={styles.alertDetails}>
                  <p className={styles.alertTitle}>{alert.title}</p>
                  <p className={styles.alertMessage}>{alert.message}</p>
                  <span className={styles.alertMeta}>
                    {alert.alertType} • Priority {alert.priority} • {alert.occurrenceCount} occurrence(s)
                  </span>
                </div>
              </div>
              <span className={`${styles.statusBadge} ${styles[alert.status]}`}>{alert.status}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
